module.exports = __webpack_public_path__ + "static/media/grab_alc_leo_490_12.0b3cecda.jpg";